import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SafeSelectRegistryService {
  private activeInstance: { close: () => void } | null = null;

  open(instance: { close: () => void }): void {
    if (this.activeInstance && this.activeInstance !== instance) {
      this.activeInstance.close();
    }
    this.activeInstance = instance;
  }

  closed(instance: { close: () => void }): void {
    if (this.activeInstance === instance) {
      this.activeInstance = null;
    }
  }
}
